module.exports = __webpack_public_path__ + "static/img/honor3.2dc0bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/honor3.png
// module id = GB6W
// module chunks = 1